import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dataValorOriginal: null,
    dataJuros: null,
    dataAtualizacao: null,
    calculos: [],
  },
  mutations: {
    SET_DATA_VALOR_ORIGINAL(state, novaData) {
      state.dataValorOriginal = novaData;
    },
    SET_DATA_JUROS(state, novaData) {
      state.dataJuros = novaData;
    },
    SET_DATA_ATUALIZACAO(state, novaData) {
      state.dataAtualizacao = novaData;
    },
    ADD_CALCULO(state, novoCalculo) {
      state.calculos.push(novoCalculo);
    },
    REMOVE_CALCULO(state, indice) {
      state.calculos.splice(indice, 1);
    },
    CLEAR_CALCULOS(state) {
      state.calculos = [];
    },
    SET_CALCULOS(state, calculos) {
      state.calculos = calculos;
    },
  },
  actions: {
    setDataValorOriginal({ state, commit }, novaData) {
      commit("SET_DATA_VALOR_ORIGINAL", novaData);
      //Se dataValorOriginal for posterior às dataJuros ou dataAtualizacao, atualiza estas duas últimas para o valor da primeira
      if (novaData > state.dataJuros) {
        commit("SET_DATA_JUROS", novaData);
      }
      if (novaData > state.dataAtualizacao) {
        commit("SET_DATA_ATUALIZACAO", novaData);
      }
    },
    setDataJuros({ commit }, novaData) {
      commit("SET_DATA_JUROS", novaData);
    },
    setDataAtualizacao({ state, commit }, novaData) {
      commit("SET_DATA_ATUALIZACAO", novaData);
      //Se dataAtualizacao for anterior à dataJuros, atualiza a última para o valor da primeira
      if (novaData < state.dataJuros) {
        commit("SET_DATA_JUROS", novaData);
      }
    },
    addCalculo({ commit }, novoCalculo) {
      commit("ADD_CALCULO", novoCalculo);
    },
    removeCalculo({ commit }, indice) {
      commit("REMOVE_CALCULO", indice);
    },
    clearCalculos({ commit }) {
      commit("CLEAR_CALCULOS");
    },
    setCalculos({ commit }, calculos) {
      commit("SET_CALCULOS", calculos);
    },
  },
  modules: {},
});
